module.exports = __webpack_public_path__ + "static/img/ic-order.b8571ec8.jpg";